/**
 * Copyright IBM Corp. 2022, 2026
 */

'use client'

import IoVideoBlock, { IoVideoBlockProps } from 'components/io-video-block'
import s from './style.module.css'

// DUPLICATE COMPONENT: from page builder (SupportVideoBlock)
// different top/bottom padding
export default function VideoFeature(props: IoVideoBlockProps) {
	return (
		<div className={s.videoFeature}>
			<IoVideoBlock {...props} />
		</div>
	)
}
